// extracted by mini-css-extract-plugin
module.exports = {"select":"rrl9A","icon":"Nl588"};